<script lang="ts">
  export let colors: string[] = ['#CCCCCC'];
</script>

<div class="colors-preview">
  <div class="colors-wrapper">
    {#each colors as color}
      <span class="color" style="background-color: {color};" />
    {/each}
  </div>
</div>

<style lang="scss">
  .colors-preview {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 75%;

    .colors-wrapper {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .color {
      height: 100%;
      flex: 1;
    }
  }
</style>
